import React from 'react';

import { Tab as MuiTab, Tabs as MuiTabs } from '@mui/material';
import { styled } from '@mui/material/styles';
import { TabProps } from '@mui/material/Tab';
import { tabsClasses, TabsProps } from '@mui/material/Tabs';

import { tokens } from '../../theme/styles/themeMui';

export type { TabProps, TabsProps };

export const Tab: React.ComponentType<TabProps<React.ElementType>> = styled(MuiTab)<
  TabProps<React.ElementType>
>(({ theme }) => ({
  ...tokens.typography['body-m-accent'],
  textTransform: 'none',
  padding: '12px',
  color: theme.palette.colors.content.secondary,

  '&.Mui-selected': {
    color: theme.palette.colors.content.primary,
  },

  '&:hover': {
    color: theme.palette.colors.content.primary,
  },
}));

export const Tabs: React.ComponentType<TabsProps> = styled(MuiTabs)<TabsProps>(({ theme }) => ({
  marginBottom: '20px',
  borderBottom: `1px solid ${theme.palette.colors.border.separator}`,

  [`.${tabsClasses.indicator}`]: {
    height: '3px',
    backgroundColor: theme.palette.colors.content['action-secondary'],
  },
}));
